'use client'

import {
  ContentGridItemBlock,
  type ContentGridItemBlockProps,
} from '@/blocks/ContentGridItemBlock/ContentGridItemBlock'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import type { ExpectedBlockType, GridColumnsField, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { Text } from 'ui/src/components/Text/Text'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { contentGrid } from './ContentGridBlock.css'

type ContentGridBlockProps = SbBaseBlockProps<{
  title?: string
  items: ExpectedBlockType<ContentGridItemBlockProps>
  layout?: GridColumnsField
}>

export function ContentGridBlock({ blok }: ContentGridBlockProps) {
  return (
    <GridLayout.Root {...storyblokEditable(blok)}>
      <GridLayout.Content width={blok.layout?.widths ?? '1'} align={blok.layout?.alignment ?? 'center'}>
        {blok.title && (
          <Text
            align="center"
            color="textSecondary"
            size="xs"
            uppercase={true}
            className={sprinkles({ marginTop: 'lg' })}
          >
            {blok.title}
          </Text>
        )}
        <div className={contentGrid}>
          {blok.items.map((nestedBlock) => (
            <ContentGridItemBlock key={nestedBlock._uid || nestedBlock.title} blok={nestedBlock} />
          ))}
        </div>
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
ContentGridBlock.blockName = 'contentGrid'
